import configData from './AppConfig.json'
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { AuthError, AuthResponse } from 'msal';

    const b2c = configData.b2c;
    const tenant = b2c.tenant;
    const signInPolicy = b2c.signInPolicy;
    const forgotPasswordPolicy = b2c.forgotPasswordPolicy;
    const applicationID = b2c.applicationID;
    const reactRedirectUri = window.location.href.split("#")[0];
    const logoutRedirectUri = window.location.href;
    const tenantSubdomain = tenant.split(".")[0];
    const instance = `https://${tenantSubdomain}.b2clogin.com/tfp/`;
    const signInAuthority = `${instance}${tenant}/${signInPolicy}`;
    const forgotPasswordAuthority = `${instance}${tenant}/${forgotPasswordPolicy}`;

    const config = {
      auth: {
        authority: signInAuthority,
        clientId: applicationID,
        postLogoutRedirectUri: logoutRedirectUri,
        redirectUri: reactRedirectUri,
        validateAuthority: false,
        navigateToLoginRequestUrl: false
      },
      cache: {
        cacheLocation: "sessionStorage" as const,
        storeAuthStateInCookie: false
      }
    };
    const auth = {
      scopes: [`${applicationID}`]
    };
    const options = {
      loginType: LoginType.Redirect,
      tokenRefreshUri: "${window.location.origin}/auth.html"
    };

    const AuthProvider = new MsalAuthProvider(config, auth, options);

    // Forgot Password Handler
    function handleForgotPassword(error: any) {
      if ( //forgot password
        error &&
        error.errorMessage &&
        error.errorMessage.indexOf("AADB2C90118") > -1
      ) 
      {
        AuthProvider.setAuthenticationParameters({
          authority: forgotPasswordAuthority
        });
      AuthProvider.login();
      }
      else 
      if (error &&  //user has reset password
        error.errorMessage &&
        error.errorMessage.indexOf("AADB2C90091") > -1)
      {
        AuthProvider.login();
      }
      
    }
   
    AuthProvider.registerErrorHandler(handleForgotPassword);
    // AuthProvider.handleRedirectCallback(tokenReceivedCallback: tokenReceivedCallback, errorReceivedCallback:errorReceivedCallback)
    // {

    // }
    AuthProvider.handleRedirectCallback((error:AuthError|undefined,response:AuthResponse|undefined)=>{
      if (error) {
        console.log(error);
        if(error.errorMessage.indexOf("state expected : null.") > -1 && error.errorMessage.indexOf("Invalid state.") > -1)
        {
          window.location.href = reactRedirectUri;
        }
      }
        if (response?.tokenType === "id_token" && response?.idToken.claims['tfp'] !== signInPolicy) 
        {
          AuthProvider.logout();
          window.alert("Password has been reset successfully. \nPlease sign-in with your new password.");
          //window.location.href = config.auth.redirectUri;
        } 
        else 
        if (response?.tokenType === "id_token" && response?.idToken.claims['tfp'] === signInPolicy) 
        {
          console.log("id_token acquired at: " + new Date().toString());
        }
    }
    );
export const getAccessToken = (): Promise<string> => {

  return new Promise((resolve, reject) => {
    AuthProvider.acquireTokenSilent({ scopes: [`${configData.b2c.applicationID}`] })
      .then((response) => {
        resolve(response.accessToken);
      })
      .catch((err) => {
        /// On Safari and Mobile, We are getting this error for the first time. A known issue From MSAL.
        /// So We are redirecting microsoft again. - Issue is not fixed on latest MSAL version 1.2.1.
  
        if (err.errorCode === "login_required") {
          AuthProvider.acquireTokenRedirect({ scopes: [`${configData.b2c.applicationID}`] });
        } else {
          reject(err);
        }
      });
  });
};

export default AuthProvider;
